import { MultiLocationDisplay } from '@xing-com/crate-components-multi-location-display';
import { getTrackingUrl } from '@xing-com/crate-entity-pages-common/src/tracking';

import { JobsBookmarkContainer } from '../../components/jobs-bookmark/jobs-bookmark-container';
import type { JobDetailCardFragment } from '../../graphql/fragments/job-detail-card.fragment.gql-types';

import { JobsListItemSkeleton } from './jobs-list-item.skeleton';
import * as Styled from './jobs-list-item.styles';

export type JobsListItemProps = {
  activeUntil?: JobDetailCardFragment['activeUntil'];
  title: string;
  paid?: boolean;
  companyName: string;
  city: Array<string | null | undefined>;
  refreshedAt: JobDetailCardFragment['refreshedAt'];
  url: string;
  id: string;
  bookmarkState: boolean;
  showBookmark: boolean;
  descriptionHighlight: string;
  showDescription: boolean;
};

export const JobsListItem: React.FC<JobsListItemProps> & {
  Skeleton: typeof JobsListItemSkeleton;
} = ({
  activeUntil,
  title,
  paid,
  companyName,
  city,
  refreshedAt,
  url,
  id,
  bookmarkState,
  showBookmark,
  descriptionHighlight,
  showDescription,
}) => (
  <Styled.Container>
    <Styled.InfoWrapper
      href={getTrackingUrl({
        to: url,
        trackingKey: 'viewJobProfile',
      })}
      target="_blank"
    >
      <Styled.Headline
        $paid={paid}
        fontWeight="regular"
        lineHeight="dense"
        size="large"
        noMargin
      >
        {title}
      </Styled.Headline>
      {showDescription && (
        // @ts-expect-error FIXME: SC6
        <Styled.Description
          size="small"
          dangerouslySetInnerHTML={{ __html: descriptionHighlight }}
        />
      )}
      <Styled.CompanyInfo noMargin size="medium">
        <MultiLocationDisplay
          locations={[companyName, ...city].filter(Boolean)}
        />
      </Styled.CompanyInfo>
      <Styled.OptimisticPublicationDate
        noMargin
        date={refreshedAt}
        activeUntil={activeUntil}
      />
    </Styled.InfoWrapper>
    {showBookmark && (
      <JobsBookmarkContainer
        jobId={id}
        bookmarked={bookmarkState}
        isSubpage={true}
      />
    )}
  </Styled.Container>
);

JobsListItem.Skeleton = JobsListItemSkeleton;
